import { DatepickerTranslations } from '../interfaces/datepicker-translations.interface';

export const DEFAULT_DATEPICKER_TRANSLATIONS: DatepickerTranslations = {
	'datepicker.calendar_week': 'CW',
	'datepicker.weekday.sun': 'Sun',
	'datepicker.weekday.mon': 'Mon',
	'datepicker.weekday.tue': 'Tue',
	'datepicker.weekday.wed': 'Wed',
	'datepicker.weekday.thu': 'Thu',
	'datepicker.weekday.fri': 'Fri',
	'datepicker.weekday.sat': 'Sat',
	'datepicker.months.0': 'January',
	'datepicker.months.1': 'February',
	'datepicker.months.2': 'March',
	'datepicker.months.3': 'April',
	'datepicker.months.4': 'May',
	'datepicker.months.5': 'June',
	'datepicker.months.6': 'July',
	'datepicker.months.7': 'August',
	'datepicker.months.8': 'September',
	'datepicker.months.9': 'October',
	'datepicker.months.10': 'November',
	'datepicker.months.11': 'December',
	'datepicker.disabled': 'Date is disabled',
	'datepicker.excluded': 'Date is excluded',
};
